import { FaqComponent } from './faq/faq.component';
import { InstructionsComponent } from './instructions/instructions.component';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { WebsitePageRoutingModule } from './website-routing.module';

import { WebsitePage } from './website.page';
import { register } from 'swiper/element/bundle';
import { RequestEventComponent } from './request-event/request-event.component';
register();

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    WebsitePageRoutingModule,
    RequestEventComponent
  ],
  declarations: [
    WebsitePage,
    InstructionsComponent,
    FaqComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class WebsitePageModule {}
